class CollapsibleElement extends HTMLElement {
  connectedCallback() {
    this.controller = this.querySelector('[aria-expanded]');
    this.controller.addEventListener('click', this.toggle.bind(this));
  }

  /**
   * find the content element
   */
  findContent() {
    const id = this.controller.getAttribute('aria-controls');
    this.content = document.getElementById(id);
  }

  /**
   * Close sibling collapsibles in the same container
   */
  closeSiblings() {
    const container = this.closest('[data-collapsible-group]');
    if (container) {
      const siblings = container.querySelectorAll('collapsible-element');
      siblings.forEach((sibling) => {
        if (sibling !== this) {
          sibling.close();
        }
      });
    }
  }

  /**
   * Open the collapsible element
   */
  open() {
    if (this.dataset.closeSiblings === 'true') {
      this.closeSiblings();
    }
    this.findContent();
    this.controller.setAttribute('aria-expanded', 'true');
    this.content.setAttribute('aria-hidden', 'false');
  }

  /**
   * Close the collapsible element
   */
  close() {
    this.findContent();
    this.controller.setAttribute('aria-expanded', 'false');
    this.content.setAttribute('aria-hidden', 'true');
  }

  /**
   * Toggle the collapsible element
   */
  toggle() {
    const isExpanded = this.controller.getAttribute('aria-expanded') === 'true';
    isExpanded ? this.close() : this.open();
  }
}

customElements.define('collapsible-element', CollapsibleElement);
